import TomSelect from 'tom-select';

(() => {
	// Initialize tom-select for ALL contact form services multiselects
	const initTomSelect = () => {
		// Find ALL services-select elements on the page
		const servicesSelects = document.querySelectorAll('#services-select, .js-services-multiselect');

		if (!servicesSelects.length) {
			console.log('No services selects found');
			return;
		}

		servicesSelects.forEach((selectEl, index) => {
			// Skip if already initialized
			if (selectEl.tomselect) {
				console.log(`TomSelect ${index} already initialized`);
				return;
			}

			console.log(`Initializing TomSelect ${index}`, selectEl);

			try {
				new TomSelect(selectEl, {
					plugins: ['remove_button'],
					placeholder: 'Select services of interest...',
					maxItems: null,
					create: false
				});
				console.log(`TomSelect ${index} created successfully`);
			} catch (error) {
				console.error(`TomSelect ${index} initialization error:`, error);
			}
		});
	};

	// Try to initialize on DOMContentLoaded
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTomSelect);
	} else {
		initTomSelect();
	}

	// Also initialize when contact modal opens (for hidden elements)
	document.addEventListener('click', (e) => {
		if (e.target.classList.contains('toggle-contact') || e.target.closest('.toggle-contact')) {
			// Small delay to ensure modal is visible
			setTimeout(initTomSelect, 150);
		}
	});
})();